import { render, staticRenderFns } from "./PostsListEmpty.vue?vue&type=template&id=5768ce2c&scoped=true&"
import script from "./PostsListEmpty.vue?vue&type=script&lang=js&"
export * from "./PostsListEmpty.vue?vue&type=script&lang=js&"
import style0 from "./PostsListEmpty.vue?vue&type=style&index=0&id=5768ce2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5768ce2c",
  null
  
)

export default component.exports